import React from "react"

export const Eka02LessonsBox = ({ lessonsActive, toggleLessons }) => {
  return (
    <div
      className={`notification has-text-mitternachtsblau is-white`}
      style={{
        transition: ".6s ease",
        maxHeight: lessonsActive ? "800px" : "0px",
        gridArea: "1/1",
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        paddingTop: lessonsActive ? "2rem" : "0px",
        paddingBottom: lessonsActive ? "2rem" : "0px",
        opacity: lessonsActive ? "1" : "0",
      }}
    >
      <button
        className="delete"
        onClick={toggleLessons}
        onKeyDown={() => {}}
        aria-label="lessons toggle"
      ></button>

      <div className="level ">
        <div className="level-left">
          <div className="level-item mb-0">Lektion 1</div>
          <div className="level-item mt-0 has-text-weight-bold">
            Ablauf eines Vergabeverfahrens
          </div>
        </div>
        <div className="level-right mt-0 has-text-grey">
          <div className="level-item">Lektion</div>
        </div>
      </div>

      <div className="level ">
        <div className="level-left">
          <div className="level-item mb-0">Lektion 2</div>
          <div className="level-item mt-0 has-text-weight-bold">
            Dokumentation im Vergabeverfahren
          </div>
        </div>
        <div className="level-right mt-0 has-text-grey">
          <div className="level-item">Lektion</div>
        </div>
      </div>

      <div className="level ">
        <div className="level-left">
          <div className="level-item mb-0">Lektion 3</div>
          <div className="level-item mt-0 has-text-weight-bold">
            Bieterfragen im Vergabeverfahren
          </div>
        </div>
        <div className="level-right mt-0 has-text-grey">
          <div className="level-item">Lektion</div>
        </div>
      </div>

      <div className="level ">
        <div className="level-left">
          <div className="level-item mb-0">Lektion 4</div>
          <div className="level-item mt-0 has-text-weight-bold">
            Rüge im Vergabeverfahren
          </div>
        </div>
        <div className="level-right mt-0 has-text-grey">
          <div className="level-item">Lektion</div>
        </div>
      </div>

      <div className="level ">
        <div className="level-left">
          <div className="level-item mb-0">Lektion 5</div>
          <div className="level-item mt-0 has-text-weight-bold">
            Finales Quiz
          </div>
        </div>
        <div className="level-right mt-0 has-text-grey">
          <div className="level-item">Quiz</div>
        </div>
      </div>
    </div>
  )
}
